import routes from '@/config/routes';
import { v3Get, v3Put } from '../axios.instance.V3';
import { ApiResponse } from '../types';

export const getAllMasusers = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.mas.getMasUsers}${clientId}`);

export const changeMasUser = (applicationId: number, newMasUserId: number): ApiResponse =>
  v3Put(`${routes.backendUrl.mas.changeMasUser}${applicationId}/${newMasUserId}`);
